export default {
  transactionsOfferActivies: 'offers',
  transactionsRewardedCoins: 'reports',
  settingsThreshold: 'coin-threshold-management',
  dashboardCreditCardTransations: 'reports',
  dashboardRewardedCoins: 'reports',
  dashboardCustomersRegistred: 'reports',
  transactionsBasicReports: 'reports',
  transactionsRewardsReports: 'reports',
  settingsCoinRules: 'coins-rules',
  customerListTotalRewards: 'customers',
  customerListTotalVisits: 'customers',
  customerListLastSeen: 'customers',
  customerListCustomerDetails: 'customers',
  newOnboarding: 'new-onboarding',
  newManageLoyaltyPage: 'new-manage-loyalty-page',
  newRefundPage: 'new-refund-page',
  newCoinImagePage: 'new-coin-image-page',
  homepage: 'home-page',
  responsiveDashboard: 'responsive-dashboard',
  merchantDashboardReports: 'merchant-dashboard-reports',
  businessReferral: 'business-referral',
  referralProgram: 'referral-program',
  legacyReports: 'legacy-reports',
  activationEmails: 'activation-emails',
  customerImport: 'customer-import',
  socialRewards: 'dashboard-social-rewards',
  newCardOnOverviewRedeemedCoins: 'new-card-on-overview-redeemed-coins',
  newSectionPerformanceActivityTotalSpend:
    'new-section-performance-activity-total-spend',
  newSellCoinsFlow: 'new-sell-coins-flow',
  sellCoinsCampaignManagement: 'ops-sell-coins-campaign-management',
  customerAcquisition: 'customer-acquisition',
  timezoneInFilters: 'dashboard-timezone-in-filters', // deprecated
  access3dCoin: 'access-3d-coin',
  videoEducation: 'dashboard-video-education',
  startGuide: 'dashboard-start-guide',
  businessSignupCaptcha: 'business-signup-captcha',
  businessCoinSetupReserveCaptcha: 'business-coin-setup-captcha',
  businessCoinSetupUploadCaptcha: 'business-coin-setup-upload-captcha',
  plaidConnect: 'plaid-connect',
  plaidTestConnect: 'plaid-test-connect',
  coin2dEditEnable: 'coin-2d-edit-enable',
  preSelectedCountry: 'dashboard-pre-selected-country',
  customerImportShopify: 'customer-import-shopify',
  newSegmentForImport: 'new-segment-for-import',
  hideSellCoinCampaignLinkSharing: 'hide-sell-coin-campaign-link-sharing',
  withoutMerchantInterface: 'without-merchant-interface',
  npoCoinImageOptional: 'npo-coin-image-optional',
  feedbackPlatform: 'dashboard-feedback-platform',
  editCustomerInactivity: 'edit-customer-inactivity',
  deactivationFeedback: 'dashboard-deactivation-feedback',
  offerRestrictionField: 'offer-restrictions',
  checkBackendAvailability: 'dashboard-check-backend-availability',
  notificationCenter: 'dashboard-notification-center',
  businessSocialLinks: 'business-social-links',
  widgetDeactivationAlerts: 'widget-deactivation-notification',
  whatIsNew: 'dashboard-what-is-new',
  disableCharacterLimitationOnOffer: 'disable-character-limitation-on-offer',
  importBusinessLogo: 'dashboard-import-business-logo',
  featuresOnboarding: 'dashboard-features-onboarding',
  enableRulesPassword: 'enable-rules-password',
  enableSignInLimit: 'enable-signin-limit',
  enableListTransactionsManager: 'list-transactions-manager',
  maintenanceMode: 'dashboard-maintenance-mode',
  offersInSpecificLocations: 'offers-in-specific-locations', // deprecated
  newSearchBar: 'dashboard-new-menu-searchbar',
  twismWalletV1: 'twism-wallet-v1',
  billingModuleV1: 'billing-module-v1',
  twismWalletSendCoins: 'twism-wallet-send-coins',
  loyaltyProgramStatus: 'loyalty-program-status',
  activateFidelPlusWixRewardsCore: 'activate-fidel-plus-wix-in-rewards-core',
  addWixMultipleIntegration: 'add-wix-on-multiple-integration',
  loyaltyProgramDeactivation: 'loyalty-program-deactivation',
  websiteFieldOnOfferCreation: 'dashboard-website-field-on-offer-creation',
  coinStoreV1: 'coin-store-v1',
  coinStoreAutoSendingCoins: 'coin-store-auto-sending-coins',
  billingModuleV2: 'billing-module-v2',
  dashboardSellCoinsAndLoyaltVerify: 'dashboard-sell-coins-and-loyalt-verify',
  sfoMerchantSignUpFlowOptimization: 'sfo-merchant-sign-up-flow-optimization',
  newCoinIcon: 'new-coin-icon',
  updateBusinessSellCoins: 'update-business-sell-coins', // deprecated
  billingModuleV3: 'billing-module-v3',
  billingModuleV4: 'billing-module-v4',
  segmentSanitizer: 'segment-sanitizer',
  createAccountPageExperiment: 'create-account-page-experiment',
  dashboardFavoritesBusinessMetric: 'dashboard-favorites-business-metric', // deprecated
  openingHours: 'merchant-opening-hours',
  enableInStoreInviteCustomer: 'dashboard-enable-in-store-invite-customer',
  dashboardOffersListV2: 'dashboard-offers-list-v2',
  dashboardBusinessOwnershipExperienceWithCoins:
    'dashboard-business-ownership-experience-with-coins',
  dashboardBusinessOwnershipLoginHandle:
    'dashboard-business-ownership-login-handle',
  smartBusinessSignupEnableSmartApisInAISignup:
    'smart-business-signup-enable-smart-apis-in-ai-signup',
  showOnboardingCallBanner: 'dashboard-show-onboarding-call-banner',
  salesOnboardingCallRequired: 'sales-onboarding-call-required',
  unifiedOfferCreation: 'dashboard-unified-offer-creation',
  offerRedemptionTiming: 'dashboard-offer-redemption-timing',
  coinRevenueOverview: 'dashboard-coin-revenue-overview',
  newMerchantPortal: 'new-merchant-portal',
  billingV2: 'billing-overview-interface-v2',
  offerDailyRenewal: 'offer-daily-renewal',
  hideBillingInterface: 'hide-billing-interface',
  usOnboardingRelaunch: 'us-onboarding-relaunch-v1',
  welcomeCoinsInterfaceV2: 'welcome-coins-interface-v2',
  myProgramsCatalogTransition: 'my-programs-catalog-transition'
};
